import { Feature } from "common/types";

import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useFeatures } from "client/clinics/hooks";

import { DetailSubscription, EligibleRetentionOffer, ListSubscription } from "../../types";
import {
  getRetentionOfferDeadlineFinePrint,
  getRetentionOfferDeliveryDisplay,
  getRetentionOfferDiscountDisplay,
} from "../../utils";

export type SubscriptionRetentionOfferAcceptedStepProps = {
  subscription: DetailSubscription | ListSubscription;
  offer: EligibleRetentionOffer;
  onDone: () => void;
};

/** Confirms an accepted offer, since the Autoship the client came to cancel is left untouched. */
const SubscriptionRetentionOfferAcceptedStep = ({
  subscription,
  offer,
  onDone,
}: SubscriptionRetentionOfferAcceptedStepProps) => {
  const isEdbEnabled = useFeatures()[Feature.AutoshipEDB];
  const delivery = getRetentionOfferDeliveryDisplay(subscription, { isEdbEnabled });
  const description = [
    `Your Autoship will continue on its current schedule, and your extra ${getRetentionOfferDiscountDisplay(
      offer,
    )} discount will be automatically applied to ${delivery}.`,
    getRetentionOfferDeadlineFinePrint(offer, { isEdbEnabled }),
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ConfirmationDialog
      title="Thanks for staying with us!"
      description={description}
      confirmText="Done"
      onConfirm={onDone}
      onDeny={onDone}
      hasDenyButton={false}
    />
  );
};

export default SubscriptionRetentionOfferAcceptedStep;
